import './PracticeIntro.scss'

import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive'
import parse from 'html-react-parser'
import cn from 'classnames'

import Author from '../Author/Author'
import Loading from '../../../templates/Loading'
import PracticeVideo from '../PracticeVideo'

export default function PracticeIntro({
  isLoading,
  practiceData,
  authors,
  getMinutes,
  handleStartButton,
  practiceType
}) {
  const isLargeScreen = useMediaQuery({ minWidth: 768 })

  const [title, setTitle] = useState()
  const [contentText, setContentText] = useState()
  const [contentTime, setContentTime] = useState()
  const [videoUrl, setVideoUrl] = useState()
  const [videoCaptions, setVideoCaptions] = useState()
  const [contentInstructions, setContentInstructions] = useState()

  useEffect(() => {
    const isEmpty = Object.keys(practiceData).length === 0

    // setting practice title, video duration, captions, content text and instructions
    if (!isEmpty) {
      setTitle(practiceData.title?.rendered || practiceData.title)

      setContentText(practiceData.content?.rendered)

      setContentInstructions(practiceData.acf?.instructions)

      setContentTime(
        Math.round(parseInt(practiceData.acf_extended.video_duration))
      )

      setVideoUrl(
        practiceData.acf?.intro_video_url ||
          practiceData.acf?.tutorial_video_url
      )

      setVideoCaptions(
        practiceData.acf?.captions_url ||
          practiceData.acf?.tutorial_video_captions_url
      )
    }
  }, [practiceData])

  return (
    <>
      <Loading isLoaded={!isLoading}>
        <div
          className={cn('practice intro-cover pb-3', {
            'pt-120': isLargeScreen
          })}
        >
          <PracticeVideo
            url={videoUrl}
            captionsUrl={videoCaptions}
            isLargeScreen={isLargeScreen}
            data={practiceData}
            practiceType={practiceType}
          >
            {getMinutes && getMinutes({ isFullWidth: true, buttonSize: 'lg' })}
            {handleStartButton && handleStartButton()}
          </PracticeVideo>
          <Container
            className={`w-100 ${
              isLargeScreen ? 'pt-4' : 'practice-container pb-5'
            }`}
          >
            <Row
              className={cn('justify-content-center', {
                'practice-content pt-4': isLargeScreen
              })}
            >
              <Col>
                {/* Practice type title */}
                <h1>{title}</h1>

                {/* Video content duration */}
                {contentTime ? (
                  <span
                    className='practice-content__time'
                    hidden={!contentTime}
                  >
                    {`${contentTime} ${contentTime >= 2 ? 'mins' : 'min'}`}
                  </span>
                ) : null}

                {/* Practice type description text */}
                <div>
                  {contentText && parse(contentText)}
                  {contentInstructions && (
                    <>
                      <h5>How to prepare</h5>
                      {parse(contentInstructions)}
                    </>
                  )}
                </div>
              </Col>
            </Row>

            {/* Video button for small screens */}
            {!isLargeScreen && (
              <Row className='mb-4 flex-nowrap flex-column'>
                <Col>
                  {getMinutes &&
                    getMinutes({ isFullWidth: true, buttonSize: 'md' })}
                  {handleStartButton && handleStartButton()}
                </Col>
              </Row>
            )}

            {/* Authors container*/}
            <Row
              className={cn('practice-authors mb-5', {
                authors: isLargeScreen
              })}
            >
              {authors && (
                <>
                  <Col xs={12} className='mb-2'>
                    <h3>About the author{authors?.length > 1 && 's'}</h3>
                  </Col>
                  <Col lg={6}>
                    <Author author={authors} />
                  </Col>
                </>
              )}
            </Row>
          </Container>
        </div>
      </Loading>
    </>
  )
}
